import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class GeneralBehaviorSubjectService {

    private virtualBettingMobileCloseButton: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
    private subMenuOpen: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    constructor() { }

    public changeVirtualBettingMobileButtonStatus(status: boolean) {
        this.virtualBettingMobileCloseButton.next(status);
    }
    public getVirtualBettingMobileButtonStatus(): Observable<any> {
        return this.virtualBettingMobileCloseButton.asObservable();
    }

    public setSubMenu(status: boolean) {
        this.subMenuOpen.next(status);
    }
    public getSubMenu(): Observable<any> {
        return this.subMenuOpen.asObservable();
    }
}



// WEBPACK FOOTER //
// C:/Users/beyn/Documents/GitLab/spinmatic-casino/src/app/Modules/Shared/services/general-behavior-subject.service.ts